import { Dashboard } from "Apps/Dashboard/DashboardApp.setting";
import { MPA } from "Apps/MPA/MPAApp.setting";
import { UMS } from "Apps/UMS/UMSApp.setting";
import { isMpaUrl } from "Shared/Utils/IsMpaUrl";
import { isUMSUrl } from "Shared/Utils/isUMSUrl";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router";

const DEFAULT_APP_PATH = Dashboard.path;
const DEFAULT_MPA_APP_PATH = MPA.path;
const DEFAULT_UMS_APP_PATH = UMS.path;

const StartPageBase = () => {
    const navigate = useNavigate();

    const defaultAppPath = isMpaUrl ? DEFAULT_MPA_APP_PATH : isUMSUrl ? DEFAULT_UMS_APP_PATH : DEFAULT_APP_PATH;

    useEffect(() => {
        if (window.self === window.top) {
            navigate(defaultAppPath);
        }
    }, [defaultAppPath, navigate]);

    return <div />;
};

export const StartPage = observer(StartPageBase);
